import { useMemo, useState } from "react";

function FearScale() {
  const [value, setValue] = useState(4);
  const reflection = useMemo(() => {
    if (value <= 3) {
      return "This fear may be present, but it does not seem to dominate the room.";
    }
    if (value <= 6) {
      return "This fear may shape some choices, especially under stress.";
    }
    return "This fear may feel loud. It might deserve patience, support, and attention.";
  }, [value]);

  return (
    <section className="glass-panel rounded-lg p-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-display text-3xl text-museum-bone">Fear scale</h2>
          <label htmlFor="fear-scale" className="mt-2 block text-sm text-museum-muted">
            How strongly do you feel this fear?
          </label>
        </div>
        <p className="font-display text-4xl text-museum-gold">{value}</p>
      </div>
      <input
        id="fear-scale"
        type="range"
        min="1"
        max="10"
        value={value}
        onChange={(event) => setValue(Number(event.target.value))}
        className="mt-7 h-2 w-full cursor-pointer appearance-none rounded-full bg-museum-bone/15 accent-museum-gold"
      />
      <div className="mt-4 flex justify-between text-xs uppercase tracking-[0.2em] text-museum-muted">
        <span>quiet</span>
        <span>loud</span>
      </div>
      <p className="mt-6 rounded-lg border border-museum-bone/10 bg-museum-black/45 p-4 leading-7 text-museum-bone">
        {reflection}
      </p>
    </section>
  );
}

export default FearScale;
